import { WORKSPACE_LEFT_LIST_ICONS } from "../WorkspaceAssets/Assets";
import { getCustomisationFieldData, getCustomisationValue, getGroupData, updateCustomisationValue } from "../WorkspaceComponents/EditablePreview/EditablePreview";
import { convertUniqueFilenameToOriginal } from "./CampaignAndFeatureDataHelperFunctions";

export const workingVisualEditorData = {
    customisationVars: {},
    campaignData: {},
    activeNode: null,
};

export const findDynamicNodeName = (node, dataIndex) => {
    // console.log("findDynamicNodeName - node:", node, "dataIndex:", dataIndex);
    if (node?.config?.groupSettings?.useDynamicNaming === false) {
        return null;
    }
    // Try and pull out the subNode name from a field
    let subNodeName = null;
    let foundName = false;
    let foundFirstStringField = false;
    const nodeChildren = node?.config?.children;
    if (nodeChildren && nodeChildren.length > 0) {
        for (let j = 0; j < nodeChildren.length; j++) {
            const child = nodeChildren[j];
            if (child.module === 'copy') {
              // console.log("findDynamicNodeName - copy module found:", child);
              const copyDataLink = child.dataLink;
              if (copyDataLink) {
                const copyValue = getCustomisationValue(node.customisationVars, copyDataLink, dataIndex);
                // console.log("findDynamicNodeName - copyValue:", copyValue, "for dataLink:", copyDataLink);
                if (copyValue && ((typeof copyValue === 'string' && copyValue.trim() !== '') || typeof copyValue === 'number')) {
                    subNodeName = copyValue;
                    foundName = true;
                    break;
                } else {
                  subNodeName = 'Copy ' + (dataIndex + 1);
                  foundName = true;
                  break;
                }
              }
            }
            const fields = child?.fields;
            if (fields && fields.length > 0) {
                for (let k = 0; k < fields.length; k++) {
                    const field = fields[k];
                    // console.log("findDynamicNodeName - checking field for name:", field);
                    let dataLink = null;
                    if (child.module === 'custom' && field.customFieldConfig && field.customFieldConfig.dataLink) {
                        dataLink = field.customFieldConfig.dataLink;
                    } else if (field.dataLink) {
                        dataLink = field.dataLink;
                    }
                    // If this field's name is 'Name' or 'Label', use it for the subNode name and break out of the loop
                    if (dataLink) {
                      if (field.name?.toLowerCase() === 'title' || field.name?.toLowerCase() === 'name' || field.name?.toLowerCase() === 'label' || field.name?.toLowerCase() === 'copy' || field.label?.toLowerCase() === 'copy') {
                          const fieldValue = getCustomisationValue(node.customisationVars, dataLink, dataIndex);
                          if (fieldValue && ((typeof fieldValue === 'string' && fieldValue.trim() !== '') || typeof fieldValue === 'number')) {
                              subNodeName = fieldValue;
                              foundName = true;
                              break;
                          } else {
                              return null;
                          }
                      } else {
                          if (!foundName && (field.name?.toLowerCase().includes('title') || field.name?.toLowerCase().includes('name') || field.name?.toLowerCase().includes('label') || field.name?.toLowerCase().includes('copy') || field.label?.toLowerCase().includes('copy'))) {
                              const fieldValue = getCustomisationValue(node.customisationVars, dataLink, dataIndex);
                              if (fieldValue && ((typeof fieldValue === 'string' && fieldValue.trim() !== '') || typeof fieldValue === 'number')) {
                                  subNodeName = fieldValue;
                                  foundName = true;
                                  break;
                              }
                          }
                          if (!foundName && !foundFirstStringField) {
                              const fieldValue = getCustomisationValue(node.customisationVars, dataLink, dataIndex);
                              // console.log("findDynamicNodeName - fieldValue for potential subNode name:", fieldValue, dataLink);
                              if (fieldValue && typeof fieldValue.originalFile === 'string' && fieldValue.originalFile.trim() !== '') {
                                  subNodeName = convertUniqueFilenameToOriginal(fieldValue.originalFile);
                                  foundFirstStringField = true;
                              } else
                              if (fieldValue && typeof fieldValue.filename === 'string' && fieldValue.filename.trim() !== '') {
                                  subNodeName = convertUniqueFilenameToOriginal(fieldValue.filename);
                                  foundFirstStringField = true;
                              } else
                              if (fieldValue && typeof fieldValue.filename?.filename === 'string' && fieldValue.filename.filename.trim() !== '') {
                                  subNodeName = convertUniqueFilenameToOriginal(fieldValue.filename.filename);
                                  foundFirstStringField = true;
                              } else
                              // Colours only for other strings
                              if (fieldValue && typeof fieldValue === 'string' && fieldValue.trim() !== '' && fieldValue.startsWith('#')) {
                                  subNodeName = fieldValue;
                                  foundFirstStringField = true;
                              } else
                                  // Is this field value an object with properties that might contain a string we can use as a name?
                              if (fieldValue && typeof fieldValue === 'object') {
                                  for (let prop in fieldValue) {
                                      if (typeof fieldValue[prop]?.filename === 'string' && fieldValue[prop].filename.trim() !== '') {
                                          subNodeName = convertUniqueFilenameToOriginal(fieldValue[prop].filename);
                                          foundFirstStringField = true;
                                          break;
                                      } else
                                      if (typeof fieldValue[prop] === 'string' && fieldValue[prop].trim() !== '') {
                                          subNodeName = fieldValue[prop];
                                          foundFirstStringField = true;
                                          break;
                                      }
                                  }
                              }
                          }
                      }
                  }
                }
            }
        }
    }
    if (foundName || foundFirstStringField) {
        // Trim any names that are too long (30 chars) and add ellipsis
        if (subNodeName.length > 30) {
            subNodeName = subNodeName.substring(0, 27) + '...';
        }
    }

    // console.log("findDynamicNodeName - subNodeName:", subNodeName);
    return subNodeName;
}

export const renderNodeName = (nodeName, node, nodes, isExpandable) => {
    const addExtraIndentation = !isExpandable;
    if (node.icon) {
      return (
        <>
          {node.icon === 'add' && <div className={`${addExtraIndentation ? 'v2-workspace__left-list-name-extra-indentation ' : ''}v2-workspace__left-list-img-icon`}>+</div>}
          {node.icon !== 'add' &&
            <img className={`${addExtraIndentation ? 'v2-workspace__left-list-name-extra-indentation ' : ''}v2-workspace__left-list-img-icon`} alt='' src={WORKSPACE_LEFT_LIST_ICONS[node.icon]} />
          }
          <span className='v2-workspace__left-list-text'>{nodeName}</span>
        </>
      )
    } else {
      return <span className={`${addExtraIndentation ? 'v2-workspace__left-list-name-extra-indentation ' : ''}v2-workspace__left-list-text`}>{nodeName}</span>;
    }
  }

export const processGroupsToSubNodes = (groups, parent, topNode, lastTopVisualisedNode = null) => {
    // console.log("processGroupsToSubNodes - groups:", groups, "parent:", parent);

    processFixedSettings(groups, topNode);

    for (let i = 0; i < groups.length; i++) {
      if (groups[i].type === 'group') {
        // console.log("processGroupsToSubNodes - group:", groups[i]);
        const group = groups[i];
        const newSubNode = {
          id: parent.id + '-' + group.name.split(' ').join('_'),
          path: parent.path + '.' + group.name.split(' ').join('_'),
          name: group.name,
          config: group,
          featureData: parent.featureData,
          customisationVars: parent.customisationVars,
          topNode: topNode,
          hasChildren: group.children && group.children.length > 0,
          enabled: true,
          subNodes: [],
          depth: parent.depth + 1,
          parent: parent,
        }

        let iconType = null;
        // console.log("Decide icon type for group:", group, "parent:", parent, "children:", group.children);
        if (group.type === 'group') {
          if (parent.isVisualised || group?.visualisationConfig?.isEnabled) {
            iconType = 'visualisedGroup';
            newSubNode.isVisualised = true;
            if (newSubNode?.config?.visualisationConfig?.isEnabled) {
              lastTopVisualisedNode = newSubNode;
            } else {
              newSubNode.visualisedTopNode = lastTopVisualisedNode;
            }
          } else {
            iconType = 'settings';
          }

          let iconSet = false;
          // If we have a custom module (child.module === 'custom'), check if we have an ImageUpload field
          if (group.children && group.children.length > 0 && group.children.some(child => child.module === 'custom')) {
            const customModule = group.children.find(child => child.module === 'custom');
            // console.log("Custom module found:", customModule);
            if (customModule.fields && customModule.fields.some(field => field?.customFieldConfig?.customFieldType === 'ImageUpload')) {
              iconType = 'image';
              iconSet = true;
            }
          }
          if (!iconSet) {
            // Do we have a copy field (text) child?
            if (group.children && group.children.length > 0 && group.children.some(child => child.module === 'copy')) {
              iconType = 'text';
            } else if (group.children && group.children.length > 0 && group.children.some(child => child.module === 'image')) {
              iconType = 'image';
            } else if (group.name.toLowerCase().includes(' bar')) {
              iconType = 'progressBar';
            } else if (group.children && group.children.length > 0 && group.children.some(child => child.module === 'audio')) {
              iconType = 'audio';
            }
          }
        }

        if (iconType) {
          newSubNode.icon = iconType;
        }

        parent.subNodes.push(newSubNode);
        if (iconType === 'audio' && parent !== topNode) {
          parent.icon = 'audio';
        } else
        if (parent.icon !== 'settings' && parent !== topNode && parent.subNodes.length > 1) {
          parent.icon = 'basicGroup';
        }
        if (group.children && group.children.length > 0) {
          processGroupsToSubNodes(group.children, newSubNode, topNode, lastTopVisualisedNode);
        }

        if (group?.groupSettings?.dataLink && getCustomisationFieldData(workingVisualEditorData.campaignData, topNode.id, group.groupSettings.dataLink)?.allowMultiple) {
          newSubNode.hasChildren = true;
          newSubNode.dynamicSubNodes = true;
          // These data links for for customisations that allow multiples, we need to set hasChildren to true and our node list will
          // request the children which we can return as the list of multiple objects and an Add New option.
        }
      }
    }
  }

  export const processFixedSettings = (modules, topNode) => {
    modules.forEach(module => {
      if (module.type === 'module' && module.fields) {
        // console.log("processFixedSettings - module:", module);
        module.fields.forEach(field => {
          // console.log("processFixedSettings - field:", field);
          if (field.customFieldConfig && field.customFieldConfig.fixedValue && field.customFieldConfig.dataLink) {
            // Process fixed settings
            const fixedValue = field.customFieldConfig.fixedValue;
            const dataLink = field.customFieldConfig.dataLink;
            // Here you would typically set the customisation data based on the fixedValue and dataLink
            updateCustomisationValue(topNode.customisationVars, dataLink, fixedValue);
          }
        });
      }
    });
  }

  export const getSubNodes = (node, nodes) => {
    const nodeDupe = { ...node };
    nodeDupe.subNodes = [...node.subNodes]
    // console.log('Default getSubNodes: ', node, nodes, nodeDupe);
    const customisationConfig = getCustomisationFieldData(workingVisualEditorData.campaignData, node.topNode.id, node.config.groupSettings.dataLink);
    const customisationData = getGroupData(node.customisationVars, node.config.groupSettings.dataLink, -1); // getCustomisationValue(node.customisationVars, node.config.groupSettings.dataLink, -1);
      if (!customisationConfig) {
        node.valsArray = customisationData;
        return [];
      }
    // return nodes.filter(n => n.parent === node.id);

    const flattenSubNode = (node, parent, depth = null) => {
      const flattenedNode = { ...node };

      flattenedNode.expanded = null;
      flattenedNode.selected = null;
      delete (flattenedNode.expanded);
      delete (flattenedNode.selected);

      flattenedNode.isDynamicSubNode = node.dynamicSubNodes === true;
      flattenedNode.dynamicSubNodes = false;
      flattenedNode.parent = parent;
      flattenedNode.depth = depth !== null ? depth : (parent ? parent.depth + 1 : 0);
      flattenedNode.id = flattenedNode.id + '-' + parent.id + '-' + flattenedNode.depth;
      flattenedNode.path = flattenedNode.path + '.' + parent.path + '.' + flattenedNode.depth;
      flattenedNode.dataIndex = parent.dataIndex;
      if (flattenedNode.subNodes && flattenedNode.subNodes.length > 0) {
        for (let i = 0; i < flattenedNode.subNodes.length; i++) {
          const flattenedSubNode = flattenSubNode(flattenedNode.subNodes[i], flattenedNode, depth !== null ? depth + 1 : flattenedNode.depth + 1);
          flattenedNode.subNodes[i] = flattenedSubNode;
        }
      }
      if (!flattenedNode.subNodes || flattenedNode.subNodes.length === 0) {
        flattenedNode.hasChildren = false;
        flattenedNode.expanded = false;
      }

      if (flattenedNode.path === workingVisualEditorData.activeNode?.path) {
        flattenedNode.active = true;
      } else {
        flattenedNode.active = false;
      }

      return flattenedNode;
    }

    const newSubNodes = [];

    const subNodesToPreserve = node?.subNodesToPreserve ?? (node.subNodes ? [...node.subNodes] : []);
    node.subNodesToPreserve = subNodesToPreserve;

    // console.log("getSubNodes - subNodesToPreserve:", subNodesToPreserve);
    if (customisationData && Array.isArray(customisationData)) {
      if (customisationData.length > 0) {
        for (let i = 0; i < customisationData.length; i++) {
          const subNode = { ...node };

          subNode.expanded = null;
          subNode.selected = null;
          delete (subNode.expanded);
          delete (subNode.selected);

          subNode.parent = node;
          subNode.depth = node.depth + 1;
          subNode.hasChildren = false;
          subNode.subNodes = null;
          subNode.dynamicSubNodes = false;
          subNode.isVisualised = false;
          subNode.id = node.id + '-' + (i + 1);
          subNode.path = node.path + '.' + (i + 1);
          let subNodeName = node.name + ' ' + (i + 1);

          // Try and pull out the subNode name from a field
          const useDynamicNaming = node?.config?.groupSettings?.useDynamicNaming ?? true;
          if (useDynamicNaming) {
            const foundNodeName = findDynamicNodeName(node, i);
            if (foundNodeName) {
              subNodeName = foundNodeName;
            }
          }
          /* let foundName = false;
          let foundFirstStringField = false;
          const nodeChildren = node?.config?.children;
          if (nodeChildren && nodeChildren.length > 0) {
              for (let j = 0; j < nodeChildren.length; j++) {
                  const child = nodeChildren[j];
                  const fields = child?.fields;
                  if (fields && fields.length > 0) {
                      for (let k = 0; k < fields.length; k++) {
                          const field = fields[k];
                          let dataLink = null;
                          if (child.module === 'custom' && field.customFieldConfig && field.customFieldConfig.dataLink) {
                              dataLink = field.customFieldConfig.dataLink;
                          } else if (field.dataLink) {
                              dataLink = field.dataLink;
                          }
                          // If this field's name is 'Name' or 'Label', use it for the subNode name and break out of the loop
                          if (dataLink) {
                              if (field.name.toLowerCase() === 'name' || field.name.toLowerCase() === 'label') {
                                  const fieldValue = getCustomisationValue(node.customisationVars, dataLink, i);
                                  if (fieldValue && typeof fieldValue === 'string' && fieldValue.trim() !== '') {
                                      subNodeName = fieldValue;
                                      foundName = true;
                                      break;
                                  }
                              } else {
                                  if (!foundName && (field.name.toLowerCase().includes('name') || field.name.toLowerCase().includes('label'))) {
                                      const fieldValue = getCustomisationValue(node.customisationVars, dataLink, i);
                                      if (fieldValue && typeof fieldValue === 'string' && fieldValue.trim() !== '') {
                                          subNodeName = fieldValue;
                                          foundName = true;
                                          break;
                                      }
                                  }
                                  if (!foundName && !foundFirstStringField) {
                                      const fieldValue = getCustomisationValue(node.customisationVars, dataLink, i);
                                      if (fieldValue && typeof fieldValue === 'string' && fieldValue.trim() !== '') {
                                          subNodeName = fieldValue;
                                          foundFirstStringField = true;
                                      }
                                  }
                              }
                          }
                      }
                  }
              }
          }
          if (foundName || foundFirstStringField) {
              // Trim any names that are too long (30 chars) and add ellipsis
              if (subNodeName.length > 30) {
                  subNodeName = subNodeName.substring(0, 27) + '...';
              }
          } */

          subNode.name = subNodeName;
          subNode.dataIndex = i;
          subNode.valsArray = customisationData;
          subNode.removable = true;
          subNode.topNode = node?.topNode ?? node;
          // subNode.visualisedTopNode = node?.visualisedTopNode ?? node;
          if (subNode.path === workingVisualEditorData.activeNode?.path) {
            subNode.active = true;
          } else {
            subNode.active = false;
          }

          if (subNodesToPreserve && subNodesToPreserve.length > 0) {
            subNode.hasChildren = true;
            subNode.subNodes = [];
            for (let j = 0; j < subNodesToPreserve.length; j++) {
              subNode.subNodes[j] = flattenSubNode(subNodesToPreserve[j], subNode, subNode.depth + 1);
            }
          }

          newSubNodes.push(subNode);
          // console.log("getSubNodes - new subNode:", subNode);
        }
      } else {
        node.valsArray = customisationData;
      }
    }

    // console.log("getSubNodes - newSubNodes:", newSubNodes, customisationConfig);

    // Add the Add New button node
    if (customisationConfig.allowMultiple) {
      const addButtonSubNode = { ...node };
      addButtonSubNode.id = node.id + '-add';
      addButtonSubNode.path = node.path + '.add';
      addButtonSubNode.name = 'Add New';
      addButtonSubNode.dataIndex = -1;
      addButtonSubNode.hasChildren = false;
      addButtonSubNode.subNodes = null;
      addButtonSubNode.dynamicSubNodes = false;
      addButtonSubNode.active = false;
      addButtonSubNode.selected = false;
      addButtonSubNode.expanded = false;
      addButtonSubNode.isAddButton = true;
      addButtonSubNode.valsArray = customisationData;
      addButtonSubNode.varSchema = customisationConfig;
      addButtonSubNode.icon = 'add';
      newSubNodes.push(addButtonSubNode);
    }

    return newSubNodes;
  };

